import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';

@Injectable({
  providedIn: 'root',
})
export class LearningAssignmentHttpService extends SupabaseBaseHttpService<'assignments', 'learning'> {
  readonly schema = 'learning';
  readonly tableName = 'assignments';
}
